import { WindowWithBinoban } from './types'

declare const window: WindowWithBinoban

const identify = (userId: string) => {
    if (typeof window === 'undefined' || !window.Binoban) return
    window.Binoban.identify(userId)
}

const getAnonymousId = () => {
    if (typeof window === 'undefined' || !window.Binoban) return
    return window?.Binoban?.user?.().anonymousId?.()
}

const adsClickedEvent = (index: number | null, bidId: string | null) => {
    if (!window.Binoban) return
    window.Binoban.track('ads_click', {
        bid_id: bidId,
        index,
    })
}

const adsImpressionedEvent = (index: number | null, bidId: string | null) => {
    if (!window.Binoban) return
    window.Binoban.track('ads_impression', {
        bid_id: bidId,
        index,
    })
}

const productAddedEvent = (productId: string, category: string, variant: string, sellerId: string) => {
    if (!window.Binoban) return
    window.Binoban.track('product_added', {
        product_id: productId,
        category,
        variant,
        seller_id: sellerId,
    })
}

export const Binoban = {
    identify,
    adsClickedEvent,
    adsImpressionedEvent,
    productAddedEvent,
    getAnonymousId,
}
